(function(){
  "use strict";
  var SINGLE = 62.99;

  /* slide-in menu */
  var mnav = document.getElementById('mnav'), burger = document.getElementById('burger');
  function menu(open){
    mnav.classList.toggle('is-on', open);
    mnav.setAttribute('aria-hidden', open ? 'false' : 'true');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger && mnav) {
    burger.addEventListener('click', function(){ menu(!mnav.classList.contains('is-on')); });
    mnav.addEventListener('click', function(e){
      if (e.target.closest('[data-close]') || e.target.closest('a[href^="#"]')) menu(false);
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') menu(false); });
  }

  /* announcement bar — one message at a time, cross-fading */
  var ANNO = [
    'Free U.S. shipping on every order',
    '<b>60-day money-back guarantee</b>',
    'Solar &mdash; no wiring, no batteries',
    'No spikes. No netting. No gel.'
  ];
  var annoEl = document.getElementById('annoTxt');
  if (annoEl && ANNO.length > 1) {
    var ai = 0;
    setInterval(function(){
      annoEl.classList.add('is-out');
      setTimeout(function(){
        ai = (ai + 1) % ANNO.length;
        annoEl.innerHTML = ANNO[ai];
        annoEl.classList.remove('is-out');
      }, 350);
    }, 4000);
  }

  /* gallery */
  var slides = document.querySelectorAll('.gal__slide');
  var thumbs = document.querySelectorAll('.gal__thumb');
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      var i = +t.dataset.i;
      slides.forEach(function(s,n){ s.classList.toggle('is-on', n===i); });
      thumbs.forEach(function(x,n){ x.classList.toggle('is-on', n===i); });
    });
  });

  /* bundles */
  var opts=document.querySelectorAll('.bopt');
  var pNow=document.getElementById('pNow'), pOld=document.getElementById('pOld');
  var pSave=document.getElementById('pSave'), pNote=document.getElementById('pNote');
  var sNow=document.getElementById('sNow'), sOld=document.getElementById('sOld');
  function money(n){ return '$'+n.toFixed(2); }
  function apply(el){
    var price=parseFloat(el.dataset.price), units=parseInt(el.dataset.units,10);
    var each=parseFloat(el.dataset.each), full=SINGLE*units;
    pNow.textContent=money(price); sNow.textContent=money(price);
    if(units>1){
      pOld.textContent=money(full); sOld.textContent=money(full);
      pOld.style.display=sOld.style.display=''; pSave.style.display='';
      pSave.textContent='Save '+Math.round((1-price/full)*100)+'%';
      pNote.textContent=units+' units · '+money(each)+' each · free U.S. shipping';
    } else {
      pOld.style.display=sOld.style.display='none'; pSave.style.display='none';
      pNote.textContent='1 unit · covers a single rail or ledge · free U.S. shipping';
    }
  }
  opts.forEach(function(el){
    el.addEventListener('click',function(){
      opts.forEach(function(o){o.classList.remove('is-sel');});
      el.classList.add('is-sel'); apply(el);
    });
  });
  apply(document.querySelector('.bopt.is-sel'));

  /* coverage calculator */
  var cIn=document.getElementById('calcIn'), cGo=document.getElementById('calcGo'), cOut=document.getElementById('calcOut');
  function calc(){
    var n=parseInt(cIn.value,10);
    if(!n||n<1){ cOut.classList.remove('is-on'); return; }
    if(n>30) n=30;
    var pick = n<=2?0 : n<=4?1 : n<=6?2 : 3;
    var target=opts[pick];
    var label=target.querySelector('.bopt__title').textContent;
    var units=target.dataset.units;
    cOut.innerHTML='For <b>'+n+' spot'+(n>1?'s':'')+'</b> we\'d suggest the <b>'+label+'</b> pack &mdash; '+
      units+' unit'+(units>1?'s':'')+'. One unit per perching spot, because a rail around the corner is a different spot.';
    cOut.classList.add('is-on');
    opts.forEach(function(o){o.classList.remove('is-sel');});
    target.classList.add('is-sel'); apply(target);
  }
  cGo.addEventListener('click',calc);
  cIn.addEventListener('keydown',function(e){ if(e.key==='Enter') calc(); });

  /* faq */
  document.querySelectorAll('.q__b').forEach(function(b){
    b.addEventListener('click',function(){ b.parentElement.classList.toggle('is-open'); });
  });

  /* review form */
  var prForm=document.getElementById('prForm');
  document.getElementById('prWriteBtn').addEventListener('click',function(){ prForm.classList.toggle('is-on'); });
  document.getElementById('prCancel').addEventListener('click',function(){ prForm.classList.remove('is-on'); });
  var picker=document.getElementById('prPicker');
  picker.addEventListener('click',function(e){
    var v=e.target.dataset.v; if(!v) return;
    [].forEach.call(picker.children,function(s,i){ s.classList.toggle('on', i < +v); });
  });

  /* sticky bar */
  var hero=document.getElementById('buy'), sticky=document.getElementById('sticky');
  window.addEventListener('scroll',function(){
    sticky.classList.toggle('is-on', hero.getBoundingClientRect().bottom < 0);
  },{passive:true});
})();
